<template>
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-sm-6 col-md-6 col-lg-8">
        <div class="back-image">
			<video id="video" width="auto" height="100%" autoplay="" loop="" preload="auto" class="">
				<source src="/video/video.mp4">
				<source src="/video/video.webm" type="video/webm">
			</video>
		</div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-4 pl-0">
        <div class="login-form d-flex align-items-center">
          <form
            class="sign-in-sign-up-form w-100"
            ref="form"
            data-url="admin/users/login"
          >
            <div class="text-center mb-4">
              <img :src="urlGenerator(logoUrl)" alt="" class="img-fluid logo" />
            </div>
            <div class="form-row">
              <div class="form-group col-12">
                <label
				:style="'color:#fff !important'"
				>{{ $t("email") }}</label>
                <app-input
                  type="email"
                  :placeholder="$t('your_email')"
                  :required="true"
                  v-model="login.email"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12">
                <label
				:style="'color:#fff !important'"
				>{{ $t("password") }}</label>
                <app-input
                  type="password"
                  v-on:keyup.enter="submitData"
                  :placeholder="$t('your_password')"
                  :required="true"
                  v-model="login.password"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-12">
                <button
                  type="button"
                  class="btn btn-primary btn-block text-center"
                  @click="submitData"
                >
                  <span class="w-100">
                    <app-submit-button-loader v-if="loading"></app-submit-button-loader>
                  </span>
                  <template v-if="!loading">{{ $t("login") }}</template>
                </button>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 text-right">
                <a href="#" class="bluish-text" @click="forgetPassword">
                  <i data-feather="lock" class="pr-2" />{{ $t("forgot_password") }}?
                </a>
              </div>
            </div>
            <div class="form-group">
              <div class="col-12">
                <p class="text-center mt-5 footer-copy"
				:style="'color:#fff !important'"
				>
                  {{ copyRightText() }}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
import { companyName, copyRightText, urlGenerator } from "../../../Helpers/helpers";
import { FormSubmitMixin } from "../../../Mixins/Global/FormSubmitMixin";

export default {
  name: "Login",
  props: {
    configData: {
      type: Object,
    },
    previousUrl: {
      type: String,
    },
  },
  mixins: [FormSubmitMixin, ThemeMixin],
  data() {
    return {
      companyName,
      copyRightText,
      urlGenerator,
      login: {},
    };
  },
  computed: {
    bannerUrl() {
      return this.configData.company_banner ?? "/images/banner.jpg";
    },
    logoUrl() {
      return this.configData.company_logo ?? "/images/logo.png";
    },
  },
  methods: {
    submitData() {
      this.save(this.login);
    },
    afterSuccess({ data }) {
      window.location.href = this.previousUrl;
    },
    afterError(response) {
      this.loading = false;
      this.$toastr.e(response.data.message);
    },
    forgetPassword() {
      location.replace(urlGenerator(`users/password-reset`));
    },
  },
};
</script>
